// MediaCover.jsx
import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import ModalImage from 'react-modal-image';
import {
  DEFAULT_PROFILE_COVER_PHOTO_URL,
  isKnownDefaultCoverPhoto,
} from '../../utils/profileCompletion';
import {
  LAUNCH_VISIT_EVENTS,
  trackLocalOpsLaunchEvent,
} from '../../utils/localOpsLaunchEvents';
import './mediaCover.css';

export const PROFILE_DEFAULT_COVER_CTA_HREF =
  '/playermap?intent=post_task&source=profile_default_cover';
export const PROFILE_DEFAULT_COVER_CTA_ID =
  'profile_default_cover_post_task_clicked';

const emitDefaultCoverCtaTelemetry = () => {
  try {
    const result = trackLocalOpsLaunchEvent({
      eventName: LAUNCH_VISIT_EVENTS.CTA_CLICKED,
      sourceTag: 'profile_default_cover',
      routeKind: 'profile_default_cover',
      intent: 'post_task',
      ctaId: PROFILE_DEFAULT_COVER_CTA_ID,
    });
    if (result && typeof result.catch === 'function') {
      result.catch(() => false);
    }
  } catch (err) {
    // best effort only
  }
};

const handleDefaultCoverCtaClick = (event) => {
  event.stopPropagation();
  emitDefaultCoverCtaTelemetry();
};

function LocalOpsDefaultCover({ title = null }) {
  return (
    <div
      className="profileCoverImg localops-default-cover"
      data-testid="localops-default-cover"
      role="img"
      aria-label="JG LocalOps default cover: Need something done? Post a Local Task. Watch it get done."
      title={title || undefined}
    >
      <div className="localops-default-cover__map" aria-hidden="true">
        <span className="localops-default-cover__pin localops-default-cover__pin--one" />
        <span className="localops-default-cover__pin localops-default-cover__pin--two" />
        <span className="localops-default-cover__route" />
      </div>
      <div className="localops-default-cover__content">
        <span className="localops-default-cover__eyebrow">JG LocalOps</span>
        <h2>Need something done?</h2>
        <p className="localops-default-cover__hook">
          Post a Local Task. Watch it get done.
        </p>
        <p className="localops-default-cover__proof">
          Nearby helpers can accept. You approve completion.
        </p>
        <p className="localops-default-cover__categories">
          Errands | pickups | ride help | yard work | home help
        </p>
      </div>
      <a
        className="localops-default-cover__cta"
        href={PROFILE_DEFAULT_COVER_CTA_HREF}
        data-testid="localops-default-cover-cta"
        onClick={handleDefaultCoverCtaClick}
      >
        Post a Local Task
      </a>
      <div className="localops-default-cover__tagline">
        Local help. Real people. Action nearby.
      </div>
    </div>
  );
}

function MediaCover({
  isVideo,
  isTube,
  mediaSource,
  handleVideoLoad,
  parent,
  player1 = null,
}) {
  const { player } = useContext(AuthContext);
  let title = null;
  const normalizedMediaSource = String(mediaSource || '').trim();
  const isPlayerProfileCover = parent === 'playerProfile';
  const showLocalOpsDefaultCover =
    isPlayerProfileCover &&
    !isVideo &&
    (!normalizedMediaSource ||
      isKnownDefaultCoverPhoto(normalizedMediaSource));

  if (
    parent === 'playerProfile' &&
    player1?.playerId === player?.data?.player?.playerId
  ) {
    title = `${player1.playerId}, click to change your cover photo`;
  }

  if (isVideo) {
    if (isTube) {
      let videoId;
      if (mediaSource.includes('youtu.be')) {
        videoId = mediaSource.split('youtu.be/')[1];
      } else if (mediaSource.includes('m.youtube.com')) {
        videoId = mediaSource.split('?v=')[1];
      } else if (mediaSource.includes('youtube.com/live')) {
        videoId = mediaSource.split('live/')[1];
      } else {
        videoId = mediaSource.split('v=')[1];
      }

      return (
        <iframe
          id="ytplayer"
          className="galaxyProfileCoverImg"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&enablejsapi=1`}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      );
    } else {
      return (
        <video
          className={
            parent === 'galaxyProfile'
              ? 'galaxyProfileCoverImg'
              : 'profileCoverImg'
          }
          src={mediaSource}
          controls
          autoPlay
          loop
          muted
          onLoadedData={handleVideoLoad}
        />
      );
    }
  } else {
    if (showLocalOpsDefaultCover) {
      return <LocalOpsDefaultCover title={title} />;
    }

    return player1?.playerId === player?.data?.player?.playerId ? (
      <img
        className={
          parent === 'galaxyProfile'
            ? 'galaxyProfileCoverImg'
            : 'profileCoverImg'
        }
        src={
          mediaSource ||
          DEFAULT_PROFILE_COVER_PHOTO_URL
        }
        alt=""
        title={title}
      />
    ) : (
      <ModalImage
        hideDownload={true}
        small={
          mediaSource ||
          DEFAULT_PROFILE_COVER_PHOTO_URL
        }
        large={
          mediaSource ||
          DEFAULT_PROFILE_COVER_PHOTO_URL
        }
        className={
          parent === 'galaxyProfile'
            ? 'galaxyProfileCoverImg'
            : 'profileCoverImg'
        }
        alt=""
      />
    );
  }
}

export default MediaCover;
